import OrderList from './list';



export default {
    list: OrderList,
};